module.exports = {
  ACTIONS: "actions",
  ACTION_STATUS: "actionstatus",
  ADDRESS: "address",
  ADDRESS_TYPES: "addresstypes",
  ADHOC: "adhoc",
  ADHOC_PAYMENTS: "adhocpayments",
  AGRESSO_GROUPS: "agressogroups",
  AGRESSO_TAX_CODES: "agressotaxcodes",
  AUDIT: "audit",
  BILLING: "billing",
  BILLING_DASHBOARD: "billingdashboard",
  BILLING_EMAIL_OPTIONS: "billingemailoptions",
  BILLING_EXCEPTION: "billingexception",
  BILLING_FREQUENCY: "billingfrequency",
  BUSINESS_UNITS: "businessunits",
  CALC: "calc",
  CALENDAR: "calendar",
  CALLING_CARD: "callingcard",
  CARRIER: "carrier",
  CASE: "case",
  CASE_REASONS: "casereasons",
  CHECKLIST_QUESTIONS: "checklistquestions",
  CLAIMB_ASIS_REASONS: "claimbasisreasons",
  COLLECTION: "collection",
  COLLECTION_CARD: "collectioncard",
  COLLECTION_EVENT_FORMAT: "collectioneventformat",
  COLLECTION_EVENTS: "collectionevents",
  COLLECTION_POINT_STYPE: "collectionpointstype",
  COLLECTION_TRANSACTION: "collectiontransaction",
  COLLECTION_DELIVERY: "collectondelivery",
  CON_AUDIT: "conaudit",
  CON_ORDERS: "conorders",
  CON_REASONS: "conreasons",
  CONSIGNMENT: "consignment",
  CONSIGNMENT_DASHBOARD: "consignmentdashboard",
  CONSUMER: "consumer",
  CONSUMER_PROPERTY: "consumerproperty",
  CONTAINERS: "containers",
  COUNTRY: "country",
  CREDIT_REASONS: "creditreasons",
  CURRENCY: "currency",
  CUSTOMER: "customer",
  CUSTOMERS: "customers",
  CUSTOMERS_ADDRESS: "customersaddress",
  CUSTOMERS_DASHBOARD: "customersdashboard",
  CUSTOMERS_GROUP: "customersgroup",
  CUSTOMERS_PROFILE: "customersprofile",
  CUSTOMERS_RANGES: "customersranges",
  CUSTOMERS_STORES: "customersstores",
  CUSTOMER_STATUS: "customerstatus",
  CUST_PREFS: "custprefs",
  CUST_RANGE: "custrange",
  CUST_RATES: "custrates",
  DELIVERY_STATE_REASONS: "deliverystatereasons",
  DEPOT: "depot",
  DEPOT_CONTACT_TYPES: "depotcontacttypes",
  DEPOT_DASHBOARD: "depotdashboard",
  DEPOT_DRIVER_ROUTE: "depotdriverroute",
  DEPOT_MSG: "depotmsg",
  DEPOT_MSG_TYPE: "depotmsgtype",
  DEPOT_ROUTE: "depotroute",
  DEPOT_ROUTES: "depotroutes",
  DEPOT_ROUTES_DASHBOARD: "depotroutesdashboard",
  DEPOT_ROUTES_IMAGES: "depotroutesimages",
  DEPOTS: "depots",
  DEPOTS_IMAGES: "depotsimages",
  DETEST_OBJECT: "detestobject",
  DIARY: "diary",
  DOCUMENTATION: "documentation",
  DRILL: "drill",
  DRIVER: "driver",
  DRIVERS: "drivers",
  DRIVER_TYPES: "drivertypes",
  EXCEPT: "except",
  EXTENDED_EXPORT_EVENTS: "extendedexportevents",
  FILES: "files",
  FILTER: "filter",
  GENERIC: "generic",
  HELD_EXPORT: "heldexport",
  HELD_STATUS: "heldstatus",
  HERMES_CLIENT: "hermes_client",
  IDENTITY_TYPE: "identitytype",
  INVOICE: "invoice",
  INVOICE_DOCTYPE: "invoicedoctype",
  INVOICE_GROUPS: "invoicegroups",
  INVOICE_SUMMARY_OPTIONS: "invoicesummaryoptions",
  ISSUES: "issues",
  KEYS: "keys",
  LABELS: "labels",
  LABEL_TYPE: "labeltype",
  LISTS: "lists",
  MAPPING: "mapping",
  MATRIX: "matrix",
  MESS: "mess",
  NETWORKS: "networks",
  NOTIFY: "notify",
  NOTIFY_TYPES: "notifytypes",
  NO_TRACE_REASONS: "notracereasons",
  OPTIMISATION: "optimisation",
  OVERRIDE: "override",
  PARCEL: "parcel",
  PARCEL_EVENT_FORMAT: "parceleventformat",
  PARCEL_EVENTS: "parcelevents",
  PARCELS: "parcels",
  PARCELS_SBADL: "parcels.sbadl",
  PARCEL_TRANSACTION: "parceltransaction",
  PARMS: "parms",
  PAYMENT: "payment",
  PAYMENT_DASHBOARD: "paymentdashboard",
  PAYMENT_METHODS: "paymentmethods",
  PAYMENT_REASONS: "paymentreasons",
  PAYMENT_REJECT_REASONS: "paymentrejectreasons",
  PAYMENT_TERMS: "paymentterms",
  PAYMENT_TYPES: "paymenttypes",
  PICKUP_DASHBOARD: "pickupdashboard",
  PICKUP_LOCATIONS: "pickuplocations",
  PICKUP_LOCATIONS_GROUPS: "pickuplocationsgroups",
  PICKUP_VOUCHERS: "pickupvouchers",
  POPUP: "popup",
  POSTCODE: "postcode",
  POSTCODE_OVERRIDE: "postcodeoverride",
  PRICE: "price",
  PRICING: "pricing",
  PRINT_GROUPS: "printgroups",
  PRODUCT: "product",
  QUOTE: "quote",
  QUOTE_CHARGES: "quotecharges",
  QUOTE_DASHBOARD: "quotedashboard",
  QUOTE_PROFILE: "quoteprofile",
  QUOTE_RATES: "quoterates",
  QUOTE_REVIEW_TYPES: "quotereviewtypes",
  QUOTE_TYPES: "quotetypes",
  REPORT: "report",
  RETURNS: "returns",
  RFI_REASONS: "rfireasons",
  ROUTE: "route",
  ROUTE_CONFIG: "routeconfig",
  ROUTE_DRIVER: "routedriver",
  RUN_SHEET: "runsheet",
  SAFE_PLACE: "safeplace",
  SATURN: "saturn",
  SATURN_DEVICE: "saturndevice",
  SCHEDULE: "schedule",
  SEARCH: "search",
  SECURITY: "security",
  SERVICE: "service",
  SERVICE_EXTRACT: "serviceextract",
  SHIFT_MANAGERS: "shiftmanagers",
  SHIPPER: "shipper",
  SORT: "sort",
  STOPS: "stops",
  SUR_CHARGE_TYPES: "surchargetypes",
  SYSTEM: "system",
  TARIFF_TYPE: "tarifftype",
  TASK: "task",
  TEXT: "text",
  TICKER: "ticker",
  TOTE: "tote",
  TRAILER: "trailer",
  UPGRADE_SERVICE: "upgradeservice",
  USER: "user",
  USER_POSITIONS: "userpositions",
  VAT: "vat",
  VEHICLE: "vehicle",
  VEHICLE_OWNERSHIP: "vehicleownership",
  VEHICLES: "vehicles",
  VEHICLE_TYPES: "vehicletypes",
  WATCH: "watch",
  YELLOW_CARD: "yellowcard",
  ZONE: "zone",
  ZONE_AREA: "zonearea",
  ZONE_MATRIX: "zonematrix",
  PARCELS_FINDER: "parcelsfinder",
  USERS: "users",
  DAILY_MATRIX: "dailymatrix",
  COLLECTIONS: "collections",
  COUNTRY_TRANSIT: "countrytransit",
  DEPOT_SATURN5_USAGE_TYPES: "depotsaturn5usagetypes",
  PARCEL_INSTRUCTIONS: "parcelinstructions",
  CUSTOMERS_TRANSACTIONS: "customerstransactions",
  ROAD_SPEEDS: "roadspeeds",
};
